import styled from "styled-components";

export const OTAManagementContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const OTAManagementHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  border-bottom: 1px solid #e9e9e9;
  background: #ffffff;
`;

export const OTAManagementTitle = styled.div`
  font-family: "Readex Pro", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 36px;
  color: #172a3f;
  cursor: default;
`;

export const VersionInfo = styled.div`
  font-size: 11px;
  color: #94a3b8;
  text-align: right;
  line-height: 1.4;
`;

export const ViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px 32px 80px;
  box-sizing: border-box;
`;
